var Cookie = {      
    status : false,
    constructor :  function(config){
        this.global  = typeof(myStorage.get('global')) === 'undefined' ? false : true;  //true - no popup
        this.config = config;
        this.upper  = typeof(myStorage.get('upper')) === 'undefined' ? false : 1*myStorage.get('upper');
        this.used   = typeof(myStorage.get('used')) === 'undefined' ? false : 1*myStorage.get('used');
        this.state   = typeof(myStorage.get('state')) === 'undefined' ? false : JSON.parse(myStorage.get('state'));
        this.fbl     = typeof(myStorage.get('fbl')) === 'undefined' ? false : 1*myStorage.get('fbl');
        this.replaceOld();
        this.initiateCheck();
        this.setStatusNoSession();
        return this;
    },
    replaceOld : function(){
        if(this.fbl == 1 && this.state == false){
            var inner = {};
            inner.facebook = 1;
            myStorage.set('state', JSON.stringify(inner) ,3000 );
            this.state = inner;
        }
    },
    initiateCheck : function(){
        if(this.upper === false){
            myStorage.set('upper', 0, this.config.expire );
            this.upper = 0;
        }
        if(this.used === false){
            myStorage.set('used', 0, this.config.expire );
            this.used = 0;
        }
        if(this.state === false){
            myStorage.set('state', JSON.stringify({}) , 3000 );
            this.state = {};
        }    
    },
    setStatusNoSession : function(){    
        if(this.state !== false && typeof(Cookies.get('state')) !== 'undefined'){
            if(MyStorage.checkSessionTime('state') == false){
                myStorage.set('state', JSON.stringify(this.state) , 3000 );
            }
        }   
    },
    check : function(){
        this.globalState();
        if(this.global === false){
            if (this.upper >=  this.config.wait && this.used < this.config.max) {
                if((this.upper - this.config.wait) % this.config.between == 0 || this.upper - this.config.wait == 0){
                    this.status = true;     
                    myStorage.set('used', this.used + 1,this.config.expire);
                }
            }
            myStorage.set('upper', this.upper + 1, this.config.expire);
        }    
    },
    globalState : function(){
        for( var el in this.state ) {
            if( this.state.hasOwnProperty( el ) ) {
                this.global = true;
            }
        }    
    },
    popup : function(){
        if(this.status === true){
            setTimeout(function(){
                modalRun();
                }, this.config.time);
        }
    },
    getStatus : function(){
        return this.status;
    }
}
var modalRun = function(){
    console.log(1111);
}
var Like = {
    constructor :  function(config){
        this.state   = typeof(myStorage.get('state')) === 'undefined' ? false : JSON.parse(myStorage.get('state'));
        return this;
    },
    pageLike : function(channel, id, type) {
        console.log(channel + ' like');
        $.modal.close();
        this.state[channel] = 1;
        myStorage.set('state', JSON.stringify(this.state) , 3000 );
        $.ajax(
            {
                type: "POST",
                url: '/social/like/' + channel,
                data : {
                    id : id,
                    type: type
                },
                headers:{
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
        });
    },

    pageUnLike : function (channel, id, type) {
        console.log(channel + ' unlike');
        this.state[channel] = 1;
        delete this.state[channel];
        myStorage.set('state', JSON.stringify(this.state) , 3000 );
        $.ajax(
            {
                type: "POST",
                url: '/social/unlike/' + channel,
                data : {
                    id : id,
                    type: type
                },
                headers:{
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
        });
    },
    TurnOff : function (channel, id){
        $.ajax(
            {
                type: "POST",
                url: '/social/off/' + id,
                headers:{
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
        });
    }
}
var GetWidget = {
    combine : {},
    constructor:  function(socialStatus, priority, state, def){
        this.socialStatus  = socialStatus
        this.priority = priority;
        this.state  = state;
        this.def = def;
        this.combineStatusState();
        return this;
    },
    detectOne: function( obj ) {
        for( var el in obj ) {
            if( obj.hasOwnProperty( el ) ) {
                if( obj[el] > 0){
                    return true;
                }
            }
        }
        return false;
    },
    combineStatusState : function(){
        var combine = {};
        for( st in this.state ) {
            if( this.state.hasOwnProperty( st ) ) {
                combine[st] = typeof(this.socialStatus[st]) !== 'undefined' ? 1*this.socialStatus[st] * this.state[st] : this.state[st]
                if(1*combine[st] == 0){
                    delete combine[st];     
                }
            }
        } 
        this.combine = combine;
    },
    findWidget : function(){                        
        if($.isEmptyObject(this.combine) === false){      
            if($.isEmptyObject(this.priority) !== false){
                return this.randomKey(this.combine);
            }
            for( pr in this.priority ) {
                if( this.priority.hasOwnProperty( pr ) && this.combine[pr] == 1) {
                    return pr;
                }
            }
            return Object.keys(this.combine)[0];
        }
        return this.def;              
    },
    randomKey : function (obj) {
        var keys = Object.keys(obj)
        return keys[ keys.length * Math.random() << 0];
    }
}